import { useEffect, useState } from "react";
import { reportExportExcelApi } from "../../resources/helper/reportsHelpers";

interface UseDownloadReportExcelProps {
  trigger: boolean;
  reportBody: any;
  filename?: string;
  onFinish?: () => void;
}

export const useDownloadReportExcel = ({
  trigger,
  reportBody,
  filename = "reporte.xlsx",
  onFinish,
}: UseDownloadReportExcelProps) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Blob | null | Error>(null);

  useEffect(() => {
    const fetchAndDownload = async () => {
      setLoading(true);
      setError(null);
      try {
        const blob = await reportExportExcelApi(reportBody);
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${filename}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);

        if (onFinish) onFinish();
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    if (trigger) {
      fetchAndDownload();
    }
  }, [trigger, reportBody]);

  return { loading, error };
};
